import { render, staticRenderFns } from "./CProductsShop.vue?vue&type=template&id=f76ae022&"
import script from "./CProductsShop.vue?vue&type=script&lang=js&"
export * from "./CProductsShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports